

const Timetable = () => {

    const contents = [
        {
         id: 0,
            day: "Friday",
            time: "18:00-19:00",
            exercise: "Kundalini Yoga",
            teacher: "Luna",
            price: "£20",
            status: "Full",
            waitingList: true  
        },

        {
           id: 1,
            day: "Saturday",
            time: "09:00-10:00",
            exercise: "Hatha Yoga",
            teacher: "Luna",
            price: "£20",
            status: "Full",
            waitingList: true  
        },

        {
            id: 2,
            day: "Sunday",
            time: "10:00-11:00",  
            exercise: "Vinyasa Yoga",
            teacher: "Luna",
            price: "£20",
            status: "Full",
            waitingList: true
        }
    ]
        const row = contents.map(item => <tr key = {item.id}> <td className="pl-6 px-2">{item.day}</td> <td className="px-2">{item.time}</td> <td className="px-4">{item.exercise}</td><td className="pl-3">{item.teacher}</td><td className="pl-2">{item.price}</td><td className="pl-4">{item.status}</td> </tr>)
            


    return (

<div className="timetable overflow-x-auto overscroll-x-contain">
<table className="min-w-[720px] border-[#3215d4] border-4">
    <thead className=" bg-blue-300 text-sm md:text-xl font-mono"> 
    <tr>
        <th scope="col" className="text-[#153243]">Day</th>
        <th scope="col" className="text-[#153243]">Time</th>
        <th scope="col" className="text-[#153243]">Class</th>
        <th scope="col" className="text-[#153243] pr-10">Teacher</th>
        <th scope="col" className="text-[#153243] pr-10">Price</th>
        <th scope="col" className="text-[#153243] pr-10">Status</th>
    </tr>
    </thead>

    <tbody className="bg-blue-400">
{row}
    </tbody>
</table>
 </div>

    )
}
export default Timetable;